import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Alert from "src/components/Alert";
import AmazonTable from "src/components/AmazonTable";
import { loadCustomers } from "src/redux/actions/amazon";
import SyncStatus from "src/components/SyncStatus";

function Customers() {
  const customers = useSelector((state) => state.amazon.customers);
  const data = useMemo(() => customers.data, [customers]);
  const dispatch = useDispatch();
  const [pageCount, setPageCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);
  const [sortBy, setSortBy] = useState();
  const [loading, setLoading] = useState(false);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "customerName",
      },
      {
        Header: "Email",
        accessor: "customerEmail",
      },
      {
        Header: "Deskera Code",
        accessor: "deskeraId",
      },
      {
        Header: "Sync Status",
        accessor: "syncStatus",
        Cell: ({ cell: { row } }) => {
          return (
            <SyncStatus
              status={row.original.syncStatus}
              reason={row.original.reason}
              id={row.original.cartCustomerId}
            />
          );
        },
        disableGlobalFilter: true,
      },
      {
        Header: "Sync Remarks",
        accessor: "reason",
        disableSortBy: true,
        Cell: ({ cell: { row } }) => {
          return <>{!(row.original.syncStatus === "SUCCESSFUL") && row.original.reason}</>;
        },
      },
    ],
    []
  );

  const refreshData = ({ pageSize, pageIndex, sortBy }) => {
    setPageSize(pageSize);
    setPageIndex(pageIndex);
    setLoading(true);
    setSortBy(sortBy);

    let updatedSortBy = sortBy?.length ? sortBy : [{ id: "syncStatus", desc: false }];
    dispatch(loadCustomers(pageSize, pageIndex, updatedSortBy));
  };

  useEffect(() => {
    setLoading(false);
    if (data && data.totalPages) {
      setPageCount(data.totalPages);
    }
  }, [data]);

  const amazonConfig = useSelector((state) => state.amazon.config);

  return (
    <div className="p-4">
      <h3 className="mb-3">Customers</h3>
      {!amazonConfig.data.syncEnabled && (
        <Alert type="warning">
          Your synced customers will appear here. Please complete{" "}
          <Link to="/app/amazon" className="text-alert-warning">
            <u>Setup</u>
          </Link>{" "}
          before continuing.
        </Alert>
      )}
      <AmazonTable
        data={data.content ? data.content : []}
        columns={columns}
        cart="amazon"
        syncButton={false}
        refresh={refreshData}
        pageCount={pageCount}
        loading={loading}
        rowId="id"
      />
    </div>
  );
}

export default Customers;
